
export abstract class BaseData {
  content: any;
  data: any;
  error: any;
  input: any;
}
